<template>
    <supplier-table :user-id="userId" :token="token"></supplier-table>
</template>

<script>
import SupplierTable from './SupplierTable.vue'

export default {
    props: {
        userId: {
            type: [Number, String, null],
            default: null,
        },
        token: {
            type: [String, null],
            default: null,
        },
    },
    components: {
        SupplierTable,
    },
}
</script>
